import React from 'react';
import ScheduleList from '../components/Schedule/List';
import SubHeading from '../contact-subheading';
import AboutUsSection from '../unit/unit-section';

const InfoVisitor = (props) => (
  <div className="info-visitor">
    {(props?.Descriptions || props?.Ingress) && (
      <AboutUsSection>
        {props?.Ingress && <p dangerouslySetInnerHTML={{ __html: props.Ingress }} />}
        {props?.Descriptions &&
          props.Descriptions?.map((rule, key) => <p key={key}>{rule}</p>)}
      </AboutUsSection>
    )}
    {props.VisitingHours?.Schedule && (
      <>
        <SubHeading Heading={props.Translations?.visitinghours} />
        <div className="schedule-list__list__container">
          <ScheduleList List={props.VisitingHours?.Schedule} />
        </div>
      </>
    )}
  </div>
);

export default InfoVisitor;
